import script from "./SingleImageUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleImageUploader.vue?vue&type=script&setup=true&lang=js"

import "./SingleImageUploader.vue?vue&type=style&index=0&id=1b48842d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b48842d"]])

export default __exports__